export enum TimeSlotEligibility {
  Eligible = 'eligible',
  SubscriptionUpgradeRequired = 'upgrade your subscription to enable booking this timeslot',
  NotAllowedByPaymentPlan = 'not allowed on current payment plan',
  NotAllowedFirstSessionMustBePeak = 'first session must be peak',
}
